import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        occurrence: '=',
        canManageOccurrences: '=',
        course: '='
    },
    template: `
        <div class="well">
            <courses-courses-edit-occurrence-steps-employee
                occurrence="vm.occurrence"
                can-manage-occurrences="vm.canManageOccurrences"
                course="vm.course"
                context="'add'"
            />
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/add/employee/index.js